// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3Pgp5","tab":"Tabs_tab__2nLeJ","tabActive":"Tabs_tabActive__n3W43"};